import { useEffect, useState } from "react";
import { DataHora } from "./Grid";
import styled from "styled-components";
import api from "../api";
import axios from "axios";

const isProd = process.env.NODE_ENV === "production";
const API_URL = isProd
  ? "https://api.assaicartola2.shop/api/"
  : "http://localhost:5137/api/";

const BtnAprovar = styled.button`
  margin-top: 4px;
  padding: 6px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  font-size: 0.85rem;
  background: ${p => p.variant === "pago" ? "#27ae60" : p.variant === "rejeitado" ? "#c0392b" : "#2980b9"};
  color: #fff;
  &:hover { opacity: 0.85; }
  &:disabled { background: #aaa; cursor: not-allowed; }
`;

const SaquePendenteBox = styled.div`
  border: 2px solid #f39c12;
  border-radius: 8px;
  background: #fef9e7;
  padding: 10px 14px;
  margin-bottom: 10px;
`;

const BadgeStatus = styled.span`
  display: inline-block;
  margin-top: 6px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 0.78rem;
  font-weight: bold;
  background: ${p =>
    p.status === "PAGO"        ? "#d5f5e3" :
    p.status === "PENDENTE"    ? "#fef9e7" :
    p.status === "PROCESSANDO" ? "#d6eaf8" :
    p.status === "REJEITADO"   ? "#f9ebea" : "#eee"};
  color: ${p =>
    p.status === "PAGO"        ? "#1e8449" :
    p.status === "PENDENTE"    ? "#b7950b" :
    p.status === "PROCESSANDO" ? "#1a5276" :
    p.status === "REJEITADO"   ? "#922b21" : "#777"};
`;

const ExtratoItem = styled.div`
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color:  ${props => props.movimento === 2 ? '#d4edda' : '#ffe5e5'};
`;

const Linha = styled.div`
  margin-bottom: 4px;
  font-size: 16px;
`;

const LinhaCenter = styled.div`
  margin-bottom: 4px;
  font-size: 16px;
  text-align: center;
`;

const RelatorioBox = styled.div`
  border: 1px solid #dce6f1;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 16px;
  background: #f8fbff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);

  @media print {
    box-shadow: none;
    border-color: #cfd8e3;
  }
`;

const RelatorioCabecalho = styled.div`
  padding: 20px 22px;
  background: linear-gradient(90deg, #1f4e79 0%, #2d6ea8 100%);
  color: #000;

  @media print {
    padding: 14px 16px;
  }
`;

const RelatorioImprimivel = styled.div`
  @media print {
    body * {
      visibility: hidden;
    }

    &, & * {
      visibility: visible;
    }

    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    padding: 0;
    margin: 0;
  }
`;

const RelatorioTitulo = styled.h3`
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
`;

const RelatorioDados = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 13px;
  opacity: 0.95;
`;

const RelatorioHeader = styled.div`
  display: grid;
  grid-template-columns: 120px 1.5fr 110px 110px 110px;
  gap: 10px;
  padding: 12px 14px;
  background: #eaf2ff;
  font-size: 13px;
  font-weight: 700;
  color: #2c3e50;

  @media print {
    font-size: 12px;
    padding: 10px 12px;
  }
`;

const RelatorioLinha = styled.div`
  display: grid;
  grid-template-columns: 120px 1.5fr 110px 110px 110px;
  gap: 10px;
  padding: 12px 14px;
  border-top: 1px solid #eaeaea;
  align-items: center;
  font-size: 14px;
  color: #34495e;
`;

const ValorPositivo = styled.span`
  color: #27ae60;
  font-weight: 600;
`;

const ValorNegativo = styled.span`
  color: #c0392b;
  font-weight: 600;
`;

const NoPrint = styled.div`
  @media print {
    display: none !important;
  }
`;

const BtnExportar = styled.button`
  margin: 12px 0 8px;
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  background: #2980b9;
  color: #fff;
  cursor: pointer;
  font-weight: 700;

  &:hover {
    opacity: 0.9;
  }
`; 




/*

async function DadosUsuario(idUsuario) {
  try {
    const res = await api.get("liga/dadosUsuario/"+idUsuario);
    setUsuario(res.data);
  } catch (error) {
    //toast.error(error.message);
  }
};*/


const DescricaoFinanceiro = ({ financeiro, adm, modoRelatorio = false }) => {

  const [usuario, setUsuario] = useState(null);
  const [timesUsuario, setTimesUsuario] = useState([]);
  // lista de saques pendentes do usuário (apenas para admin)
  const [saquesPendentes, setSaquesPendentes] = useState([]);
  const [processando, setProcessando] = useState({});

  const getDados = async () => {
    try {
      const idUsuario = financeiro?.[0]?.idUsuario;
      if (!idUsuario) {
        setUsuario(null);
        setTimesUsuario([]);
        return;
      }
      const res = await api.get("liga/dadosUsuario/" + idUsuario);
      setUsuario(res.data);
    } catch (error) {}
  };

  const carregarTimesDoUsuario = async (idUsuario) => {
    if (!idUsuario) {
      setTimesUsuario([]);
      return;
    }

    try {
      const res = await api.get("liga/listarTimes");
      const times = (res.data || []).filter((t) => Number(t.idUsuario) === Number(idUsuario));
      setTimesUsuario(times.map((t) => t.nome).filter(Boolean));
    } catch (error) {
      setTimesUsuario([]);
    }
  };

  const carregarSaquesPendentes = async () => {
    if (!adm || !financeiro?.length) return;
    try {
      const idUsuario = financeiro[0].idUsuario;
      const res = await axios.get(`${API_URL}liga/admin/saquesPendentes/${idUsuario}`);
      setSaquesPendentes(res.data || []);
    } catch (err) {
      console.error("Erro ao carregar saques pendentes:", err);
    }
  };

  useEffect(() => {
    const idUsuario = financeiro?.[0]?.idUsuario;
    getDados();
    carregarSaquesPendentes();
    carregarTimesDoUsuario(idUsuario);
  }, [financeiro]);

  async function aprovarSaque(saqueId) {
    setProcessando(p => ({ ...p, [saqueId]: true }));
    try {
      const res = await axios.post(`${API_URL}liga/admin/saques/${saqueId}/aprovar`);
      const { chavePix, valor, nomeUsuario } = res.data;
      setSaquesPendentes(prev => prev.filter(s => s.id !== saqueId));
      const valorFmt = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(valor);
      alert(
        `Saque aprovado!\n\nFaca a transferencia PIX manualmente:\n\nUsuario: ${nomeUsuario}\nValor: ${valorFmt}\nChave PIX: ${chavePix}\n\nCopie a chave e transfira pelo app do Mercado Pago.`
      );
    } catch (err) {
      const msg = err?.response?.data?.message || "Erro ao aprovar saque.";
      alert("Erro: " + msg);
    } finally {
      setProcessando(p => ({ ...p, [saqueId]: false }));
    }
  }

  async function rejeitarSaque(saqueId) {
    setProcessando(p => ({ ...p, [saqueId]: true }));
    try {
      await axios.put(`${API_URL}liga/admin/saques/${saqueId}/status`, { status: "REJEITADO", observacao: "Rejeitado pelo admin" });
      setSaquesPendentes(prev => prev.filter(s => s.id !== saqueId));
    } catch {
      alert("Erro ao rejeitar saque.");
    } finally {
      setProcessando(p => ({ ...p, [saqueId]: false }));
    }
  }

  const fmtValor = (value) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value || 0);

  const handleExportarPdf = () => {
    if (typeof window !== "undefined") {
      window.print();
    }
  };

  const movimentosOrdenados = [...(financeiro || [])]
    .slice()
    .sort((a, b) => (Number(a.id) || 0) - (Number(b.id) || 0));

  let saldoAcumulado = 0;
  const linhasRelatorio = movimentosOrdenados.map((f) => {
    const valor = Number(f.valor || 0);
    const delta = f.movimento === 2 ? valor : -valor;
    const saldoAntes = saldoAcumulado;
    saldoAcumulado += delta;
    return { ...f, delta, saldoAntes, saldoDepois: saldoAcumulado };
  });

    return (
        <>
          <br/><ExtratoItem movimento={(usuario?.valor ?? 0) >= 0 ? 2 : 1} key={1}>
          <LinhaCenter><strong>Saldo Atualizado: </strong>{fmtValor(usuario?.valor ?? 0)}</LinhaCenter>
          </ExtratoItem>

          {/* Seção admin: saques aguardando aprovação */}
          {adm && saquesPendentes.length > 0 && (
            <div style={{ marginBottom: 16 }}>
              <strong style={{ color: "#d35400" }}>Saques aguardando aprovacao ({saquesPendentes.length})</strong>
              {saquesPendentes.map(s => (
                <SaquePendenteBox key={s.id}>
                  <div><strong>Saque ID:</strong> {s.id}</div>
                  <div><strong>Valor:</strong> {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(s.valor)}</div>
                  <div><strong>Chave PIX:</strong> {s.chavePix}</div>
                  <div><strong>Status:</strong> {s.status}</div>
                  <div><strong>Data:</strong> {DataHora(s.dtSolicitacao)}</div>
                  <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                    <BtnAprovar
                      variant="pago"
                      disabled={processando[s.id]}
                      onClick={() => aprovarSaque(s.id)}
                    >
                      {processando[s.id] ? "Enviando PIX..." : "Aprovar (Enviar PIX)"}
                    </BtnAprovar>
                    <BtnAprovar
                      variant="rejeitado"
                      disabled={processando[s.id]}
                      onClick={() => rejeitarSaque(s.id)}
                    >
                      {processando[s.id] ? "..." : "Rejeitar"}
                    </BtnAprovar>
                  </div>
                </SaquePendenteBox>
              ))}
            </div>
          )}

            {modoRelatorio ? (
              <>
                <NoPrint>
                  <BtnExportar type="button" onClick={handleExportarPdf}>
                    Exportar PDF
                  </BtnExportar>
                </NoPrint>
                <RelatorioImprimivel>
                  <RelatorioBox>
                    <RelatorioCabecalho>
                      <RelatorioTitulo>Relatório de Saldo</RelatorioTitulo>
                      <RelatorioDados>
                        <div><strong>Usuário:</strong> {usuario?.nome || "—"}</div>
                        <div><strong>Times:</strong> {timesUsuario.length > 0 ? timesUsuario.join(", ") : "Nenhum time cadastrado"}</div>
                        <div><strong>Saldo atual:</strong> {fmtValor(usuario?.valor ?? 0)}</div>
                        <div><strong>Emitido em:</strong> {new Date().toLocaleString("pt-BR")}</div>
                      </RelatorioDados>
                    </RelatorioCabecalho>
                    <RelatorioHeader>
                  <div>Data</div>
                  <div>Descrição</div>
                  <div>Valor</div>
                  <div>Saldo antes</div>
                  <div>Saldo depois</div>
                </RelatorioHeader>
                {linhasRelatorio.length > 0 ? linhasRelatorio.map((f) => (
                  <RelatorioLinha key={f.id}>
                    <div>{DataHora(f.data)}</div>
                    <div>
                      <div><strong>{f.descricaoMovimento}</strong></div>
                      <div style={{ fontSize: 12, color: '#7f8c8d' }}>{f.proxyMovimento || (f.movimento === 2 ? 'Entrada' : 'Saída')}</div>
                    </div>
                    <div>{f.movimento === 2 ? <ValorPositivo>{fmtValor(f.valor)}</ValorPositivo> : <ValorNegativo>{fmtValor(f.valor)}</ValorNegativo>}</div>
                    <div>{fmtValor(f.saldoAntes)}</div>
                    <div>{f.saldoDepois >= 0 ? <ValorPositivo>{fmtValor(f.saldoDepois)}</ValorPositivo> : <ValorNegativo>{fmtValor(f.saldoDepois)}</ValorNegativo>}</div>
                  </RelatorioLinha>
                )) : <div style={{ padding: 14, color: '#7f8c8d' }}>Nenhum movimento encontrado.</div>}
                  </RelatorioBox>
                </RelatorioImprimivel>
              </>
            ) : (
              financeiro.map((f) => (
                <ExtratoItem key={f.id} movimento={f.movimento}>
                <Linha><strong>Id:</strong> {f.id}</Linha>
                <Linha><strong>Data:</strong> {DataHora(f.data)}</Linha>
                <Linha><strong>Movimento:</strong> {f.movimento} {f.proxyMovimento}</Linha>
                <Linha><strong>Descricao:</strong> {f.descricaoMovimento}</Linha>
                <Linha><strong>Valor:</strong> {fmtValor(f.valor)}</Linha>
                </ExtratoItem>
              ))
            )}
        </>
    )
}

export default DescricaoFinanceiro;